/*
  Lilibloom · reviews wall motion (used by sections/lb-reviews.liquid).
  The section renders every card into one pool; this deals them alternately into two rows
  that drift slowly in opposite directions, forever and without a visible seam.
  Each section queues itself with: (window.LBRevQ = window.LBRevQ || []).push([id, loopSeconds]);
*/
(function () {
  function init(id, loopSeconds) {
    var root = document.getElementById(id);
    if (!root || root.dataset.lbrevInit) return;
    root.dataset.lbrevInit = '1';
    var wrap = root.querySelector('.lbrev__rows');
    var pool = root.querySelector('.lbrev__pool');
    var rows = root.querySelectorAll('.lbrev__row');
    var items = [].slice.call(pool.children);
    if (items.length < 4) return;
    var sets = [[], []];
    items.forEach(function (el, i) { sets[i % 2].push(el); });

    var gsap, tweens = [], lastW = 0, visible = true;

    // Fill a row with enough copies of its cards to cover the screen while it drifts by one copy,
    // and return the exact distance between two copies (cards plus the gap), so the loop has no seam.
    function fill(row, set) {
      row.innerHTML = '';
      function copy(hidden) {
        set.forEach(function (el) {
          var c = el.cloneNode(true);
          if (hidden) c.setAttribute('aria-hidden', 'true');
          row.appendChild(c);
        });
      }
      copy(false);
      copy(true);
      var step = Math.abs(row.children[set.length].getBoundingClientRect().left - row.children[0].getBoundingClientRect().left);
      var copies = Math.max(2, Math.ceil(window.innerWidth / step) + 1);
      for (var k = 2; k < copies; k++) copy(true);
      return step;
    }

    function build() {
      lastW = window.innerWidth;
      tweens.forEach(function (t) { t.kill(); });
      tweens = [];
      var steps = [fill(rows[0], sets[0]), fill(rows[1], sets[1])];
      // both rows move at the same speed: one copy of the first row per loopSeconds
      var speed = steps[0] / loopSeconds;
      [0, 1].forEach(function (i) {
        var from = i === 0 ? 0 : steps[i];
        var to = i === 0 ? steps[i] : 0;
        gsap.set(rows[i], { xPercent: 0, x: from, force3D: true });
        var t = gsap.to(rows[i], { x: to, ease: 'none', duration: steps[i] / speed, repeat: -1, force3D: true });
        if (!visible) t.pause();
        tweens.push(t);
      });
    }

    LB.ready(function (g) {
      if (!g) return;
      gsap = g;
      wrap.classList.add('is-ready');
      build();

      // only move while the section is on screen
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          visible = entries[0].isIntersecting;
          tweens.forEach(function (t) { visible ? t.play() : t.pause(); });
        }).observe(root);
      }

      // rebuild when the width really changes (not when a phone's address bar hides)
      var timer;
      window.addEventListener('resize', function () {
        clearTimeout(timer);
        timer = setTimeout(function () { if (Math.abs(window.innerWidth - lastW) > 40) build(); }, 250);
      });

      root.querySelectorAll('.lb-line > span').forEach(function (sp) {
        gsap.from(sp, { yPercent: 110, duration: 1.2, ease: 'expo.out', scrollTrigger: { trigger: sp, start: 'top 88%' } });
      });
    });
  }

  var queued = window.LBRevQ || [];
  window.LBRevQ = { push: function (a) { init(a[0], a[1]); } };
  queued.forEach(function (a) { init(a[0], a[1]); });
})();